<!-- @format -->

<sis-tab-navigation [wide]="'md'" [tabs]="tabs"></sis-tab-navigation>
